import { CreditsTable } from '../../shared/CreditsTable';

export const CreditHistory = ({ appParams }) => {
  const { brandCreditRecords: credits } = appParams || {};

  return <CreditsTable credits={credits} type="brand" />;
};
